import { FC } from 'react'

import { useTheme } from '@mui/material/styles'
import {
  Breadcrumbs,
  Link,
  LinkProps,
  Typography,
  TypographyProps,
} from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

interface KBreadcrumbLinkProps extends LinkProps {
  to?: string
  replace?: boolean
}

export const KBreadcrumbLink: FC<KBreadcrumbLinkProps> = (props: any) => {
  const theme = useTheme()
  return (
    <Link
      underline="hover"
      {...props}
      component={RouterLink as any}
      fontSize={theme.typography.body2.fontSize}
    />
  )
}

export const KBreadcrumb: FC<TypographyProps> = ({ children }) => {
  return (
    <Typography color="text.primary" variant="body2">
      {children}
    </Typography>
  )
}

interface KBreadcrumbsProps {
  breadcrumbs?: { label: string; to?: string }[]
}

export const KBreadcrumbs = ({ breadcrumbs }: KBreadcrumbsProps) => {
  const theme = useTheme()
  return (
    <Breadcrumbs
      separator=">"
      sx={{
        '& .MuiBreadcrumbs-separator': {
          fontSize: theme.typography.body2.fontSize,
          paddingX: 1,
        },
      }}
    >
      {breadcrumbs?.map((breadcrumb, index) => (
        <KBreadcrumbLink
          key={index}
          to={breadcrumb.to}
          sx={{
            color: breadcrumb.to
              ? theme.palette.primary.main
              : theme.palette.text.primary,
          }}
        >
          {breadcrumb.label}
        </KBreadcrumbLink>
      ))}
    </Breadcrumbs>
  )
}
